/**
 * Data de calendário YYYY-MM-DD, sem converter fuso.
 * ISO UTC `2026-07-10T00:00:00.000000Z` permanece 10/07, não 09/07 em Brasília.
 * @param {string|Date|null|undefined} valor
 * @returns {string|null}
 */
export function dataCivil(valor) {
  if (valor == null || valor === "") return null;
  if (valor instanceof Date) {
    if (Number.isNaN(valor.getTime())) return null;
    const Y = valor.getFullYear();
    const M = String(valor.getMonth() + 1).padStart(2, "0");
    const D = String(valor.getDate()).padStart(2, "0");
    return `${Y}-${M}-${D}`;
  }
  const str = String(valor).trim();
  const prefixo = str.match(/^(\d{4}-\d{2}-\d{2})/);
  if (prefixo) return prefixo[1];
  return null;
}

/**
 * Formata valor ISO (YYYY-MM-DD ou com hora) para exibição dd/mm/aaaa.
 * @param {string|null|undefined} valor - Data em ISO ou string
 * @param {string} fallback - Texto quando valor vazio (default '-')
 * @returns {string}
 */
export function formatarDataBr(valor, fallback = "-") {
  const civil = dataCivil(valor);
  if (!civil) return fallback;
  const [ano, mes, dia] = civil.split("-");
  return `${dia}/${mes}/${ano}`;
}

/**
 * Retorna apenas a parte da data (YYYY-MM-DD) para uso em inputs type="date".
 * @param {string|null|undefined} valor
 * @returns {string}
 */
export function dataParaInput(valor) {
  return dataCivil(valor) || "";
}

/**
 * Retorna data e hora atuais no formato "YYYY-MM-DD HH:mm:ss" para envio à API.
 * @param {Date} [date] - Data a usar (default: agora)
 * @returns {string}
 */
export function dataHoraAgora(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  const Y = d.getFullYear();
  const M = String(d.getMonth() + 1).padStart(2, "0");
  const D = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  const s = String(d.getSeconds()).padStart(2, "0");
  return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}

/**
 * Retorna apenas a hora atual no formato "HH:mm:ss" (para concatenar com data de input).
 * @param {Date} [date] - Data a usar (default: agora)
 * @returns {string}
 */
export function horaAgora(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  const s = String(d.getSeconds()).padStart(2, "0");
  return `${h}:${m}:${s}`;
}

/**
 * Formata ISO datetime para dd/mm/aaaa HH:mm.
 */
export function formatarDataHoraBr(valor, fallback = "-") {
  if (!valor) return fallback;
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return formatarDataBr(valor, fallback);
  const D = String(d.getDate()).padStart(2, "0");
  const M = String(d.getMonth() + 1).padStart(2, "0");
  const data = `${D}/${M}/${d.getFullYear()}`;
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  return `${data} ${h}:${m}`;
}
